import React from "react";
import { Modal, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DeleteConfirmModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
    isLoading?: boolean;
}

export default function DeleteConfirmModal({
    open,
    onClose,
    onConfirm,
    title = "Delete Confirmation / تأكيد الحذف",
    message = "Are you sure you want to delete this item? / هل أنت متأكد أنك تريد حذف هذا العنصر؟",
    isLoading = false,
}: DeleteConfirmModalProps) {
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog" style={{ width: '800px', maxWidth: '100%' }}>
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>{title}</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close / إغلاق"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="delete_msg_content">
                        <p>{message}</p>
                    </div>

                    <div className="footer_btn_flex" style={{ marginTop: '20px' }}>
                        <Button
                            className="btn btn_grey"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel / إلغاء
                        </Button>
                        <Button
                            className="btn btn_primary"
                            onClick={onConfirm}
                            disabled={isLoading}
                            style={{ backgroundColor: '#d32f2f', color: '#fff' }}
                        >
                            {isLoading ? "Deleting... / جارٍ الحذف..." : "Delete / حذف"}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
